import Vue from 'vue';
import VueRouter from 'vue-router';
import playvideo from '../views/playvideo.vue'; //视频播放
import livevideo from '../views/livevideo.vue'; //RTC直播教室
import PortalHome from '../views/portal/Home.vue'; //门户首页
import PortalLogin from '../views/portal/Login.vue'; //门户登录页
import PortalCustomizeExamList from '../views/portal/customize/ExamList.vue'; //判题-自定义题型-考试列表
import PortalCustomizeExamAnswer from '../views/portal/customize/ExamAnswer.vue'; //判题-自定义题型-在线答题
import PortalCustomizeExamResult from '../views/portal/customize/ExamResult.vue'; //判题-自定义题型-考试结果
import PortalProblemList from '../views/portal/problem/ProblemList.vue'; //判题-核心题目-题目列表
import PortalProblemDetail from '../views/portal/problem/ProblemDetail.vue'; //判题-核心题目-题目详情
import PortalJudgeDetail from '../views/portal/problem/JudgeDetail.vue'; //判题-核心题目-提交详情
import PortalCommodityList from '../views/portal/shop/CommodityList.vue'; //商城-课程商品列表
import PortalCommodityDetail from '../views/portal/shop/CommodityDetail.vue'; //商城-商品详情
import PortalShopCar from '../views/portal/shop/ShopCar.vue'; //商城-购物车
import PortalShopFavorite from '../views/portal/shop/ShopFavorite.vue'; //商城-我的收藏
import PortalShopContact from '../views/portal/shop/ShopContact.vue'; //商城-联系老师
import PortalReportList from '../views/portal/report/PlanList.vue'; //学习报告-计划列表
import PortalReportDetail from '../views/portal/report/PlanDetail.vue'; //学习报告-计划详情
import PortalUserCenter from '../views/portal/user/UserCenter.vue'; //个人中心
import PortalStudentArchive from '../views/portal/user/StudentArchive.vue'; //个人中心-小主档案
import PortalOrderList from '../views/portal/order/OrderList.vue'; //我的订单-订单列表
import PortalOrderDetail from '../views/portal/order/OrderDetail.vue'; //我的订单-订单详情
Vue.use(VueRouter);
const routes = [
    {
        path: '/playvideo',
        component: playvideo,
        meta: { title: '视频播放' }
    },
    {
        path: '/livevideo',
        component: livevideo,
        meta: { title: '直播教室' }
    },
    //门户相关路由
    {
        path: '/portal/home',
        name: 'PortalHome',
        component: PortalHome,
        meta: { title: '首页' }
    },
    {
        path: '/portal/login',
        name: 'PortalLogin',
        component: PortalLogin,
        meta: { title: '登录' }
    },
    {
        path: '/portal/customize/exam',
        name: 'PortalCustomizeExamList',
        component: PortalCustomizeExamList,
        meta: { title: '在线考试' }
    },
    {
        path: '/portal/customize/exam/answer',
        name: 'PortalCustomizeExamAnswer',
        component: PortalCustomizeExamAnswer,
        meta: { title: '在线答题' }
    },
    {
        path: '/portal/customize/exam/result',
        name: 'PortalCustomizeExamResult',
        component: PortalCustomizeExamResult,
        meta: { title: '考试成绩' }
    },
    {
        path: '/portal/problem/list',
        name: 'PortalProblemList',
        component: PortalProblemList,
        meta: { title: '题目列表' }
    },
    {
        path: '/portal/problem/detail',
        name: 'PortalProblemDetail',
        component: PortalProblemDetail,
        meta: { title: '题目详情' }
    },
    {
        path: '/portal/problem/judge',
        name: 'PortalJudgeDetail',
        component: PortalJudgeDetail,
        meta: { title: '提交详情' }
    },
    //商城相关路由
    {
        path: '/portal/shop/list',
        name: 'PortalCommodityList',
        component: PortalCommodityList,
        meta: { title: '课程商城' }
    },
    {
        path: '/portal/shop/detail',
        name: 'PortalCommodityDetail',
        component: PortalCommodityDetail,
        meta: { title: '商品详情' }
    },
    {
        path: '/portal/shop/car',
        name: 'PortalShopCar',
        component: PortalShopCar,
        meta: { title: '购物车' }
    },
    {
        path: '/portal/shop/favorite',
        name: 'PortalShopFavorite',
        component: PortalShopFavorite,
        meta: { title: '我的收藏' }
    },
    {
        path: '/portal/shop/contact',
        name: 'PortalShopContact',
        component: PortalShopContact,
        meta: { title: '联系老师' }
    },
    //学习报告相关路由
    {
        path: '/portal/report/list',
        name: 'PortalReportList',
        component: PortalReportList,
        meta: { title: '学习报告' }
    },
    {
        path: '/portal/report/detail',
        name: 'PortalReportDetail',
        component: PortalReportDetail,
        meta: { title: '学习计划详情' }
    },
    //个人中心相关路由
    {
        path: '/portal/user/center',
        name: 'PortalUserCenter',
        component: PortalUserCenter,
        meta: { title: '个人中心' }
    },
    {
        path: '/portal/user/student',
        name: 'PortalStudentArchive',
        component: PortalStudentArchive,
        meta: { title: '小主档案' }
    },
    //我的订单相关路由
    {
        path: '/portal/order/list',
        name: 'PortalOrderList',
        component: PortalOrderList,
        meta: { title: '我的订单' }
    },
    {
        path: '/portal/order/detail',
        name: 'PortalOrderDetail',
        component: PortalOrderDetail,
        meta: { title: '订单详情' }
    },
    {
        path: '',
        redirect: '/portal/home',
        meta: { title: '首页' }
    },
    {
        path: '/',
        redirect: '/portal/home',
        meta: { title: '首页' }
    },
    //处理/site路径的请求，重定向到静态文件
    {
        path: '/site*',
        beforeEnter: (to) => {
            // 重定向到静态文件路径
            window.location.href = to.fullPath;
        }
    }
];

const router = new VueRouter({
    mode: 'history', // 改为history模式，支持标准URL
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
});

export default router;
